import React, { useMemo, useEffect, useState } from 'react'
import Modal from '../../Modal'
import { Button, Checkbox } from '@mui/material'
import { commonColors } from '../../../utils/constants'
import DragDropComponent from '../../DragDropComponent'
import { DragIndicator } from '@mui/icons-material'
import styles from './Screener.module.scss'

export default function ScreenerEditColumnsModal({open, handleClose, title, columns, handleUpdateColumns }) {
    const [ modalColumns, setModalColumns ] = useState([])

    useEffect(() => {
        setModalColumns(columns.filter(col=>col.field != "isInWatchlist"))
        return () => {}
    },[columns])

    const handleApply = () => {
        handleUpdateColumns(modalColumns)
        handleClose()
    }

    const handleUpdate = (newOrder) => setModalColumns(newOrder)
        
    const handleCheckboxClick = (field) => setModalColumns(columnsList => columnsList.map(col => (col.field !== field ? {...col} : {...col, hide: !col.hide })))

    const buttons = [
        <Button key="cancel" variant="outlined" onClick={handleClose}>CANCEL</Button>,
        <Button key="apply" variant="contained" color="active" onClick={handleApply}>APPLY</Button>,
    ]

    const items = useMemo(() => {
        return <DragDropComponent droppableId="columns" handleUpdate={handleUpdate} listItems={modalColumns} draggableKey='field'>
                {(item) => (item?.headerName ?? item.renderHeader() 
                    ? <Column key={item.field} active={!item.hide} name={item?.headerName ?? item.renderHeader()} field={item.field} handleCheckboxClick={handleCheckboxClick} disabled={item.disabled}/> 
                    : <></>
                )}
            </DragDropComponent>
    },[modalColumns]) // eslint-disable-line

    return (
        <Modal open={open} handleClose={handleClose} limitWidth={false} title={title} buttons={buttons}>
            {items}
        </Modal>
    )
}


const Column = ({active, name, field, handleCheckboxClick, dragHandleProps = {}, disabled}) => {
    const onClick = () => handleCheckboxClick(field)

    return (
        <div className={styles['columns']} disable={(!!disabled).toString()} >
            <div className={styles[disabled && 'hidden']} {...dragHandleProps} >
                <DragIndicator/>
            </div>
            <Checkbox style={{color: !disabled && commonColors.stockUp}} disabled={disabled} checked={active} onClick={onClick}/>
            {name}
        </div>
    )
}